module.exports = __webpack_public_path__ + "img/logo_login.4951490b.png";